/**
 * Build-Time Environment Loader
 * Loads the appropriate environment configuration at build time based on REACT_APP_ENV_CONFIG
 * Since this is a static app deployed to S3, environment selection happens at build time,
 * not runtime. The correct configuration is compiled into the bundle.
 */

/**
 * Get the environment configuration based on REACT_APP_ENV_CONFIG (build-time only)
 * The environment variable is read during webpack compilation and the appropriate
 * configuration is bundled into the static files.
 */
function getEnvironment() {
  // This environment variable is only available during build time
  // It gets replaced by webpack during compilation for static deployment
  const envType = process.env['REACT_APP_ENV_CONFIG'] || 'local';

  console.log(`[EnvironmentLoader] Build-time configuration selection: ${envType}`);

  try {
    switch (envType) {
      case 'dev':
        return require('./environment.dev').default;

      case 'prod':
        return require('./environment.prod').default;

      case 'local':
        try {
          return require('./environment.local').default;
        } catch (error) {
          console.warn(`[EnvironmentLoader] Local environment file not found, falling back to dev`);
          return require('./environment.dev').default;
        }

      default:
        // Handle customer account numbers (12-digit format)
        if (/^\d{12}$/.test(envType)) {
          console.log(`[EnvironmentLoader] Loading customer configuration: ${envType}`);
          return require(`./environment.${envType}`).default;
        }

        // Handle other environment files that might exist
        try {
          return require(`./environment.${envType}`).default;
        } catch (error) {
          console.warn(`[EnvironmentLoader] Environment file not found for '${envType}', falling back to dev`);
          return require('./environment.dev').default;
        }
    }
  } catch (error) {
    console.error(`[EnvironmentLoader] Failed to load environment configuration for '${envType}':`, error);
    console.warn(`[EnvironmentLoader] Falling back to development configuration`);

    // Ultimate fallback to dev configuration
    try {
      return require('./environment.dev').default;
    } catch (fallbackError) {
      console.error(`[EnvironmentLoader] Critical: Cannot load development configuration:`, fallbackError);
      throw new Error(`Failed to load any environment configuration. Please check your environment files.`);
    }
  }
}

// Export the loaded environment configuration
// Note: This is evaluated at build time, so the correct environment
// configuration gets compiled into the static bundle
const environment = getEnvironment();

export default environment;

// Also export the loader function for testing purposes
export { getEnvironment };